// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/observability.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Trace, TraceDetails } from "../v1/langfuse_pb.js";
import { file_agentplatform_v1_langfuse } from "../v1/langfuse_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/observability.proto.
 */
export const file_agentplatform_httpv2_observability: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_v1_langfuse, file_buf_validate_validate, file_gnostic_openapi_v3_annotations, file_google_api_annotations, file_google_protobuf_struct]);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListTracesRequest
 */
export type ListTracesRequest = Message<"infinigence.infini.agentplatform.httpv2.ListTracesRequest"> & {
  /**
   * 分页页码（从 1 开始；0 / 缺省 = 1）
   * @gotags: json:"page,omitempty"
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * 每页大小（最大 1000；0 / 缺省 = 20）
   * @gotags: json:"page_size,omitempty"
   *
   * @generated from field: int32 page_size = 2 [json_name = "page_size"];
   */
  pageSize: number;

  /**
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 3 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @gotags: json:"session_id,omitempty"
   *
   * @generated from field: string session_id = 5 [json_name = "session_id"];
   */
  sessionId: string;

  /**
   * @gotags: json:"from_timestamp,omitempty"
   *
   * @generated from field: string from_timestamp = 6 [json_name = "from_timestamp"];
   */
  fromTimestamp: string;

  /**
   * @gotags: json:"to_timestamp,omitempty"
   *
   * @generated from field: string to_timestamp = 7 [json_name = "to_timestamp"];
   */
  toTimestamp: string;

  /**
   * @gotags: json:"order_by,omitempty"
   *
   * @generated from field: string order_by = 8 [json_name = "order_by"];
   */
  orderBy: string;

  /**
   * @gotags: json:"tags,omitempty"
   *
   * @generated from field: repeated string tags = 9;
   */
  tags: string[];

  /**
   * @gotags: json:"version,omitempty"
   *
   * @generated from field: string version = 10;
   */
  version: string;

  /**
   * @gotags: json:"release,omitempty"
   *
   * @generated from field: string release = 11;
   */
  release: string;

  /**
   * @gotags: json:"environment,omitempty"
   *
   * @generated from field: repeated string environment = 12;
   */
  environment: string[];

  /**
   * @gotags: json:"fields,omitempty"
   *
   * @generated from field: string fields = 13;
   */
  fields: string;

  /**
   * @gotags: json:"filter,omitempty"
   *
   * @generated from field: string filter = 14;
   */
  filter: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListTracesRequest.
 * Use `create(ListTracesRequestSchema)` to create a new message.
 */
export const ListTracesRequestSchema: GenMessage<ListTracesRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 0);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListTracesResponse
 */
export type ListTracesResponse = Message<"infinigence.infini.agentplatform.httpv2.ListTracesResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListTracesData data = 4;
   */
  data?: ListTracesData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListTracesResponse.
 * Use `create(ListTracesResponseSchema)` to create a new message.
 */
export const ListTracesResponseSchema: GenMessage<ListTracesResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListTracesData
 */
export type ListTracesData = Message<"infinigence.infini.agentplatform.httpv2.ListTracesData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Trace items = 1;
   */
  items: Trace[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @gotags: json:"page"
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @gotags: json:"total_pages"
   *
   * @generated from field: int32 total_pages = 4 [json_name = "total_pages"];
   */
  totalPages: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListTracesData.
 * Use `create(ListTracesDataSchema)` to create a new message.
 */
export const ListTracesDataSchema: GenMessage<ListTracesData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetTraceDetailsRequest
 */
export type GetTraceDetailsRequest = Message<"infinigence.infini.agentplatform.httpv2.GetTraceDetailsRequest"> & {
  /**
   * @gotags: json:"trace_id"
   *
   * @generated from field: string trace_id = 1 [json_name = "trace_id"];
   */
  traceId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetTraceDetailsRequest.
 * Use `create(GetTraceDetailsRequestSchema)` to create a new message.
 */
export const GetTraceDetailsRequestSchema: GenMessage<GetTraceDetailsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetTraceDetailsResponse
 */
export type GetTraceDetailsResponse = Message<"infinigence.infini.agentplatform.httpv2.GetTraceDetailsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.TraceDetails data = 4;
   */
  data?: TraceDetails | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetTraceDetailsResponse.
 * Use `create(GetTraceDetailsResponseSchema)` to create a new message.
 */
export const GetTraceDetailsResponseSchema: GenMessage<GetTraceDetailsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMetricsRequest
 */
export type GetMetricsRequest = Message<"infinigence.infini.agentplatform.httpv2.GetMetricsRequest"> & {
  /**
   * Langfuse metrics 查询 JSON 字符串
   * @gotags: json:"input"
   *
   * @generated from field: string input = 1;
   */
  input: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMetricsRequest.
 * Use `create(GetMetricsRequestSchema)` to create a new message.
 */
export const GetMetricsRequestSchema: GenMessage<GetMetricsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetMetricsResponse
 */
export type GetMetricsResponse = Message<"infinigence.infini.agentplatform.httpv2.GetMetricsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 原始 Langfuse metrics 响应（形如 {"data": [...]}）
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Struct data = 4;
   */
  data?: JsonObject | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetMetricsResponse.
 * Use `create(GetMetricsResponseSchema)` to create a new message.
 */
export const GetMetricsResponseSchema: GenMessage<GetMetricsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 6);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSandboxMetricsRequest
 */
export type GetSandboxMetricsRequest = Message<"infinigence.infini.agentplatform.httpv2.GetSandboxMetricsRequest"> & {
  /**
   * Langfuse metrics 查询 JSON 字符串
   * @gotags: json:"input"
   *
   * @generated from field: string input = 1;
   */
  input: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSandboxMetricsRequest.
 * Use `create(GetSandboxMetricsRequestSchema)` to create a new message.
 */
export const GetSandboxMetricsRequestSchema: GenMessage<GetSandboxMetricsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 7);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetSandboxMetricsResponse
 */
export type GetSandboxMetricsResponse = Message<"infinigence.infini.agentplatform.httpv2.GetSandboxMetricsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * 原始 Langfuse metrics 响应（形如 {"data": [...]}）
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: google.protobuf.Struct data = 4;
   */
  data?: JsonObject | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetSandboxMetricsResponse.
 * Use `create(GetSandboxMetricsResponseSchema)` to create a new message.
 */
export const GetSandboxMetricsResponseSchema: GenMessage<GetSandboxMetricsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 8);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetOverviewRequest
 */
export type GetOverviewRequest = Message<"infinigence.infini.agentplatform.httpv2.GetOverviewRequest"> & {
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetOverviewRequest.
 * Use `create(GetOverviewRequestSchema)` to create a new message.
 */
export const GetOverviewRequestSchema: GenMessage<GetOverviewRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 9);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetOverviewResponse
 */
export type GetOverviewResponse = Message<"infinigence.infini.agentplatform.httpv2.GetOverviewResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.GetOverviewData data = 4;
   */
  data?: GetOverviewData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetOverviewResponse.
 * Use `create(GetOverviewResponseSchema)` to create a new message.
 */
export const GetOverviewResponseSchema: GenMessage<GetOverviewResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 10);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetOverviewData
 */
export type GetOverviewData = Message<"infinigence.infini.agentplatform.httpv2.GetOverviewData"> & {
  /**
   * @gotags: json:"agent_total"
   *
   * @generated from field: int32 agent_total = 1 [json_name = "agent_total"];
   */
  agentTotal: number;

  /**
   * @gotags: json:"app_total"
   *
   * @generated from field: int32 app_total = 2 [json_name = "app_total"];
   */
  appTotal: number;

  /**
   * @gotags: json:"sandbox_class_total"
   *
   * @generated from field: int32 sandbox_class_total = 3 [json_name = "sandbox_class_total"];
   */
  sandboxClassTotal: number;

  /**
   * @gotags: json:"sandbox_total"
   *
   * @generated from field: int32 sandbox_total = 4 [json_name = "sandbox_total"];
   */
  sandboxTotal: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetOverviewData.
 * Use `create(GetOverviewDataSchema)` to create a new message.
 */
export const GetOverviewDataSchema: GenMessage<GetOverviewData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_observability, 11);

/**
 * ObservabilityHTTPV2Service
 * Langfuse traces 列举 / trace 详情 / 指标查询，以及平台概览统计
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.ObservabilityHTTPV2Service
 */
export const ObservabilityHTTPV2Service: GenService<{
  /**
   * 列出 Langfuse traces（分页 / 过滤，按租户隔离）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ObservabilityHTTPV2Service.ListTraces
   */
  listTraces: {
    methodKind: "unary";
    input: typeof ListTracesRequestSchema;
    output: typeof ListTracesResponseSchema;
  },
  /**
   * 获取单个 trace 详情
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ObservabilityHTTPV2Service.GetTraceDetails
   */
  getTraceDetails: {
    methodKind: "unary";
    input: typeof GetTraceDetailsRequestSchema;
    output: typeof GetTraceDetailsResponseSchema;
  },
  /**
   * 查询 Langfuse 指标（Basic 鉴权）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ObservabilityHTTPV2Service.GetMetrics
   */
  getMetrics: {
    methodKind: "unary";
    input: typeof GetMetricsRequestSchema;
    output: typeof GetMetricsResponseSchema;
  },
  /**
   * 查询 Sandbox 相关 Langfuse 指标（Sandbox 鉴权）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ObservabilityHTTPV2Service.GetSandboxMetrics
   */
  getSandboxMetrics: {
    methodKind: "unary";
    input: typeof GetSandboxMetricsRequestSchema;
    output: typeof GetSandboxMetricsResponseSchema;
  },
  /**
   * 平台概览统计（Agent / App / SandboxClass / Sandbox 总数）
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ObservabilityHTTPV2Service.GetOverview
   */
  getOverview: {
    methodKind: "unary";
    input: typeof GetOverviewRequestSchema;
    output: typeof GetOverviewResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_observability, 0);

